import { Component } from '@angular/core';

/**
 * Satisfies the router config validator for the unauthenticated `/` route.
 * Authenticated visits to `/` are redirected by `defaultPostLoginRootGuard` on the parent.
 */
@Component({
  selector: 'app-default-post-login-redirect',
  standalone: true,
  template: '',
})
export class DefaultPostLoginRedirectComponent {}
